var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.55245 5.27752C3.56526 2.34993 5.94755 -0.0121187 8.87408 -0.000199227C11.8005 0.000684173 14.1734 2.37413 14.1734 5.3008V6.87668C15.9498 7.49328 17.2252 9.18147 17.2252 11.1686V15.4576C17.2252 17.9669 15.1913 19.9996 12.6832 19.9996H5.04224C2.53416 19.9996 0.500244 17.9669 0.500244 15.4576V11.1686C0.500244 9.18132 1.77589 7.49302 3.55244 6.87654L3.55245 5.27752ZM5.05244 6.6266H12.6734V5.3008C12.6734 3.20201 10.9712 1.4998 8.87244 1.4998H8.86916C6.77096 1.49062 5.06247 3.18338 5.05244 5.28252V6.6266ZM5.04224 8.1266C3.36233 8.1266 2.00024 9.48794 2.00024 11.1686V15.4576C2.00024 17.1383 3.36233 18.4996 5.04224 18.4996H12.6832C14.3632 18.4996 15.7252 17.1383 15.7252 15.4576V11.1686C15.7252 9.48794 14.3632 8.1266 12.6832 8.1266H5.04224ZM8.86294 11.4527C9.27716 11.4527 9.61294 11.7885 9.61294 12.2027V14.4237C9.61294 14.8379 9.27716 15.1737 8.86294 15.1737C8.44873 15.1737 8.11294 14.8379 8.11294 14.4237V12.2027C8.11294 11.7885 8.44873 11.4527 8.86294 11.4527Z",
    fill: "#8395A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.01543cb4f48adb339b86393f5d2839a2.svg";
export { ForwardRef as ReactComponent };